import React from "react";

import { BettingTips } from "@api-types/bet-booster/BettingTipsType";
import { QuickPlayPopupsTeams } from "@features/quick-play/desktop/common/QuickPlayPopupsTeams";
import { formatTip, formatType } from "@utils/common/bettingTipsUtils";
import { observer } from "mobx-react";

import { QuickPlayEventTime } from "../../../common/QuickPlayEventTime";

export default observer(function BettingTipsPopupBody(props: {
	tip: BettingTips;
	isEventLinkDisabled?: boolean;
}) {
	return (
		<>
			<div className="card--bbt__header">
				<div className="card--bbt__description">
					{props.tip?.description}
				</div>
			</div>

			<div className="card card--qp card--qp--scroll card--bbt u-mar--top--xsml u-padd--reset">
				<div className="card__body card--qp__body card--bbt__body">
					<QuickPlayEventTime
						startTime={props.tip.sportData.startTime}
						sportAbrv={props.tip.sportData.sportAbrv}
					/>

					{props.isEventLinkDisabled ? (
						<div className="card--qp__event card--bbt__event">
							<QuickPlayPopupsTeams
								sportData={props.tip.sportData}
								eventId={props.tip.eventId}
								sportId={props.tip.sportData.sportId}
								isLinkDisabled={props.isEventLinkDisabled}
							/>
						</div>
					) : (
						<QuickPlayPopupsTeams
							sportData={props.tip.sportData}
							eventId={props.tip.eventId}
							sportId={props.tip.sportData.sportId}
							isLinkDisabled={props.isEventLinkDisabled}
							className="card--qp__event card--bbt__event u-anchor"
						/>
					)}

					<div className="card--qp__offer">
						<div className="card--qp__item">
							<div className="card--qp__market">
								<span className="card--qp__type">
									{formatType(props.tip)}
								</span>
								:
								<strong className="card--qp__tip">
									{formatTip(props.tip)}
								</strong>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
});
